import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}


// With added support for Serviceworker:
platformBrowserDynamic().bootstrapModule(AppModule).then(() => {

  if ('serviceWorker' in navigator) {
    if(environment.serviceworker){
      // Register the SW:
      navigator.serviceWorker.register('ngsw-worker.js');
      
    }else{
      // Remove any existing SW registrations:
      navigator.serviceWorker.getRegistrations().then((registrations)=>{
        for (let registration of registrations) {
          registration.unregister();
        }
      });
    }

  }else{
    console.warn('ServiceWorker unavailable in this browser');
  }

}).catch(err => console.log(err));


// WEBPACK FOOTER //
// /app/src/main.ts